module.exports = __webpack_public_path__ + "static/media/purepaper.d478769b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/purepaper.svg
// module id = 1155
// module chunks = 37